import { createStore, createHook } from 'react-sweet-state';
import { startConnection, setSelectedWorkspaceUuid } from './actions';
import { type State, READY_TO_CONNECT } from './types';

export const actions = {
	startConnection,
	setSelectedWorkspaceUuid,
} as const;
export type Actions = typeof actions;

// @ExportForTesting
export const initialState: State = {
	connectState: READY_TO_CONNECT,
	selectedWorkspaceUuid: '',
};

const Store = createStore<State, Actions>({
	name: 'codeOneClickConnectStore',
	initialState,
	actions,
});

export const useOneClickConnectStore = createHook(Store);
